import Vue from "vue";
import Router from "vue-router";
import Components from "./pages/Components.vue";
import Presentation from "./pages/Presentation.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import About from "./pages/example-pages/AboutUs.vue";
import BlogPost from "./pages/example-pages/BlogPost.vue";
import BlogPosts from "./pages/example-pages/BlogPosts.vue";
import ContactUs from "./pages/example-pages/ContactUs.vue";
import LandingPage from "./pages/example-pages/LandingPage.vue";
import LoginPage from "./pages/example-pages/LoginPage.vue";
import PricingPage from "./pages/example-pages/PricingPage.vue";
import EcommercePage from "./pages/example-pages/EcommercePage.vue";
import ProductPage from "./pages/example-pages/ProductPage.vue";
import ProfilePage from "./pages/example-pages/ProfilePage.vue";
import SignUpPage from "./pages/example-pages/SignUpPage.vue";
import Sections from "./pages/Sections.vue";
import manageSub from "./pages/bet/cancelSub.vue";

//New
import StarterNavbar from "./layout/StarterNavbar.vue";
import TransparentNavbar from "./layout/transparentNavbar.vue";
import StarterFooter from "./layout/StarterFooter.vue";
import BetHome from "./pages/bet/index.vue";
import AustraliaReview from "./pages/bet/australiaReview.vue";
import USAReviewDetail from "./pages/bet/usaReviewDetail.vue";
import USAReview from "./pages/bet/usaReview.vue";
import Prediction from "./pages/bet/prediction.vue";
import EVPunting from "./pages/bet/evPunting.vue";
import EvDetail from "./pages/bet/evPuntingDetail.vue";
import EvDetailMain from "./pages/bet/evDetail.vue";
import Blog from "./pages/bet/blog.vue";
import BlogDetail from "./pages/bet/blogDetail.vue";
import FreeCompetions from "./pages/bet/freeCompetions.vue";
import MembersRegisteration from "./pages/bet/membersRegister.vue";
import MembersLogin from "./pages/bet/membersLogin.vue";
import TrumpyTips from "./pages/bet/trumpyTips.vue";
import PredictionList from "./pages/bet/predictionList.vue";
import PredictionDetail from "./pages/bet/predictionDetail.vue";
import PredictionDetailHome from "./pages/bet/predictionDetailHome.vue";
import PredictionSports from "./pages/bet/predictionSports.vue";
import ReviewDetail from "./pages/bet/reviewDetail.vue";
import ReviewDetailUsHome from "./pages/bet/reviewDetailUsHome.vue";
import ReviewDetailAuHome from "./pages/bet/reviewDetailAuHome.vue";
import ReviewDetailUSA from "./pages/bet/reviewDetailUSA.vue";
import Welcome from "./pages/bet/welcome.vue";


//US Bettings
// import NJ from "./pages/bet/usa/NJ.vue";
// import PA from "./pages/bet/usa/PA.vue";
// import Colorado from "./pages/bet/usa/Colorado.vue";
// import Illinois from "./pages/bet/usa/Illinois.vue";
// import Indiana from "./pages/bet/usa/Indiana.vue";
// import Iowa from "./pages/bet/usa/Iowa.vue";
// import Michigan from "./pages/bet/usa/Michigan.vue";
// import Mississippi from "./pages/bet/usa/Mississippi.vue";
// import Nevada from "./pages/bet/usa/Nevada.vue";
// import NewHampshire from "./pages/bet/usa/NewHampshire.vue";
// import NewYork from "./pages/bet/usa/NewYork.vue";
// import Oregon from "./pages/bet/usa/Oregon.vue";
// import Tennessee from "./pages/bet/usa/Tennessee.vue";
// import Virginia from "./pages/bet/usa/Virginia.vue";
// import WestVirginia from "./pages/bet/usa/WestVirginia.vue";


Vue.use(Router);

const router = new Router({
    routes: [{
            path: "/",
            redirect: "/home"
        },
        {
            path: "/home",
            name: "home",
            components: { default: BetHome, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/australiaReview",
            name: "Australia-Review",
            components: { default: AustraliaReview, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        // {
        //   path: "/NJ",
        //   name: "NJ",
        //   components: {default: NJ, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/PA",
        //   name: "PA",
        //   components: {default: PA, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Colorado",
        //   name: "Colorado",
        //   components: {default: Colorado, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Illinois",
        //   name: "Illinois",
        //   components: {default: Illinois, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Indiana",
        //   name: "Indiana",
        //   components: {default: Indiana, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Iowa",
        //   name: "Iowa",
        //   components: {default: Iowa, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Michigan",
        //   name: "Michigan",
        //   components: {default: Michigan, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Mississippi",
        //   name: "Mississippi",
        //   components: {default: Mississippi, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Nevada",
        //   name: "Nevada",
        //   components: {default: Nevada, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/NewHampshire",
        //   name: "NewHampshire",
        //   components: {default: NewHampshire, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/NewYork",
        //   name: "NewYork",
        //   components: {default: NewYork, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Oregon",
        //   name: "Oregon",
        //   components: {default: Oregon, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Tennessee",
        //   name: "Tennessee",
        //   components: {default: Tennessee, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/Virginia",
        //   name: "Virginia",
        //   components: {default: Virginia, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        // {
        //   path: "/WestVirginia",
        //   name: "WestVirginia",
        //   components: {default: WestVirginia, header: StarterNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 450}}
        // },
        {
            path: "/usaReview",
            name: "USA-Review",
            components: { default: USAReview, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/usaReviewDetail/:state_id",
            name: "USA-Review-Detail",
            components: { default: USAReviewDetail, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/reviewDetailUSA/:item_id",
            name: "review-detail-USA",
            components: { default: ReviewDetailUSA, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/reviewDetail/:item_id",
            name: "review-detail",
            components: { default: ReviewDetail, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/reviewDetailUsHome/:item_id",
            name: "review-detail-us-home",
            components: { default: ReviewDetailUsHome, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/reviewDetailAuHome/:item_id",
            name: "review-detail-au-home",
            components: { default: ReviewDetailAuHome, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/prediction",
            name: "prediction",
            components: { default: Prediction, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/predictionDetail/:item_id",
            name: "Prediction-Detail",
            components: { default: PredictionDetail, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/predictionDetailHome/:item_id",
            name: "Prediction-Detail-Home",
            components: { default: PredictionDetailHome, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/predictionSports/:sports_id",
            name: "Prediction-Sports",
            components: { default: PredictionSports, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/predictionList",
            name: "prediction-List",
            components: { default: PredictionList, header: StarterNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/evPunting",
            name: "EV-Punting",
            components: { default: EVPunting, header: TransparentNavbar, footer: StarterFooter },
            meta: {
                requiresAuth: true
            },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/evPuntingDetail/:item_id",
            name: "ev-detail",
            components: { default: EvDetail, header: TransparentNavbar, footer: StarterFooter },
            meta: {
                requiresAuth: true
            },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/evPuntingMain/:item_id",
            name: "ev-detail-main",
            components: { default: EvDetailMain, header: TransparentNavbar, footer: StarterFooter },
            meta: {
                requiresAuth: true
            },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/freeCompetions",
            name: "home",
            components: { default: FreeCompetions, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/blog",
            name: "blog",
            components: { default: Blog, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/blogDetail/:item_id",
            name: "blog-detail",
            components: { default: BlogDetail, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        // {
        //   path: "/membersLogin",
        //   name: "Members-Login",
        //   components: {default: MembersLogin, header: TransparentNavbar, footer: StarterFooter},
        //   props: {header: {colorOnScroll: 50}}
        // },
        {
            path: "/manageSub",
            redirect: "/manageSubscription"
        },
        {
            path: "/manageSubscription",
            name: "Manage-Sub",
            components: { default: manageSub, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/welcome",
            name: "Welcome",
            components: { default: Welcome, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/trumpyTips",
            redirect: "/theSystem"
        },
        {
            path: "/theSystem",
            name: "Trumpy-Tips",
            components: { default: TrumpyTips },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/membersRegisteration",
            name: "membersRegisteration",
            components: { default: MembersRegisteration, header: TransparentNavbar, footer: StarterFooter },
            props: { header: { colorOnScroll: 50 } }
        },
        {
            path: "/contact",
            name: "contact",
            components: { default: ContactUs, header: MainNavbar, footer: MainFooter },
            props: { footer: { type: 'default' } }
        },
        {
            path: "/login",
            name: "login",
            components: { default: LoginPage, header: MainNavbar },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/landing",
            name: "landing",
            components: { default: LandingPage, header: MainNavbar, footer: MainFooter },
            props: { footer: { type: 'default' }, header: { colorOnScroll: 450 } }
        },
        {
            path: "/pricing",
            name: "pricing",
            components: { default: PricingPage, header: MainNavbar, footer: MainFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/blog-post",
            name: "blog-post",
            components: { default: BlogPost, header: MainNavbar, footer: MainFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/blog-posts",
            name: "blog-posts",
            components: { default: BlogPosts, header: MainNavbar },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/ecommerce",
            name: "ecommerce",
            components: { default: EcommercePage, header: MainNavbar, footer: MainFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/product",
            name: "product",
            components: { default: ProductPage, header: MainNavbar },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/profile",
            name: "profile",
            components: { default: ProfilePage, header: MainNavbar, footer: MainFooter },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/signup",
            name: "signup",
            components: { default: SignUpPage, header: MainNavbar },
            props: { header: { colorOnScroll: 450 } }
        },
        {
            path: "/sections",
            name: "sections",
            components: { default: Sections, header: MainNavbar, footer: MainFooter },
            props: {
                footer: { backgroundColor: 'gray' },
                header: { colorOnScroll: 0 }
            }
        }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
});

export default router;